// extracted by css-extract-rspack-plugin
var _1 = "copy__yyHgk";
var _2 = "wrapper__UATWN";
export { _1 as "copy", _2 as "wrapper" }
export default { "copy": _1, "wrapper": _2 }
